const config = {
 apiBaseUrl: process.env.REACT_APP_API_BASE_URL || "https://theconsoleapi.onrender.com", // Default to localhost
   // apiBaseUrl: process.env.REACT_APP_API_BASE_URL || "http://localhost:5000", // Default to localhost
   //apiBaseUrl: process.env.REACT_APP_API_BASE_URL || "https://tgh-pack-console.onrender.com",
  };
  
  export default config;
